import * as angular from 'angular';
import {IAngularEvent, ILocationService, ILogService, IRootScopeService, ITimeoutService} from 'angular';
import {IState, IStateService} from 'angular-ui-router';
import Raven = require('raven-js');
import {ApplicationPropertyRS} from '../admin/service/applicationPropertyRS.rest';
import AuthServiceRS from '../authentication/service/AuthServiceRS.rest';
import {RouterHelper} from '../dvbModules/router/route-helper-provider';
import {TSAuthEvent} from '../models/enums/TSAuthEvent';
import {TSErrorLevel} from '../models/enums/TSErrorLevel';
import TSApplicationProperty from '../models/TSApplicationProperty';
import ErrorService from './errors/service/ErrorService';
import {NavigationLogger} from './service/NavigationLogger';
import PiwikService from './service/PiwikService';
import VereinbarungAkzeptiertService from './service/VereinbarungAkzeptiertService';
import auto = angular.auto;
import IInjectorService = auto.IInjectorService;

appRun.$inject = ['angularMomentConfig', 'RouterHelper', '$injector', '$rootScope',
    '$timeout', '$state', '$location', '$window', '$log', 'AuthServiceRS', 'ErrorService',
    'VereinbarungAkzeptiertService', 'ApplicationPropertyRS', 'PiwikService', 'NavigationLogger'];

/* @ngInject */
export function appRun(angularMomentConfig: any, routerHelper: RouterHelper,
                       $injector: IInjectorService, $rootScope: IRootScopeService, $timeout: ITimeoutService,
                       $state: IStateService, $location: ILocationService, $window: ng.IWindowService,
                       $log: ILogService, authServiceRS: AuthServiceRS, errorService: ErrorService,
                       vereinbarungAkzeptiertService: VereinbarungAkzeptiertService, applicationPropertyRS: ApplicationPropertyRS,
                       piwikService: PiwikService) {
    // navigationLogger.toggle();

    // Fehler beim Navigieren ueber ui-route ins Log schreiben
    $rootScope.$on('$stateChangeError', (event, toState, toParams, fromState, fromParams, error) => {
        $log.error('Fehler beim Navigieren');
        $log.error('$stateChangeError --- event, toState, toParams, fromState, fromParams, error');
        $log.error(event, toState, toParams, fromState, fromParams, error);
    });

    //$rootScope.$on('$locationChangeSuccess', updatePiwikStateChange); //Piwik site change marks are disabled as this feature has not been paid for

    //Normale Benutzer duefen nicht auf admin Seite
    // $rootScope.$on('$stateChangeStart',
    //     (event, toState, toParams, fromState, fromParams, options) => {
    //         let principal: TSUser = authServiceRS.getPrincipal();
    //         let forbiddenPlaces = ['admin', 'institution', 'parameter', 'traegerschaft'];
    //         let isAdmin: boolean = authServiceRS.isOneOfRoles(TSRoleUtil.getAdministratorRoles());
    //         if (toState && forbiddenPlaces.indexOf(toState.name) !== -1 && authServiceRS.getPrincipal() && !isAdmin)
    // { errorService.addMesageAsError('ERROR_UNAUTHORIZED'); $log.debug('prevented navigation to page because user is
    // not admin'); event.preventDefault(); } });

    routerHelper.configureStates(getStates(), '/start');
    angularMomentConfig.format = 'DD.MM.YYYY';
    // dieser call macht mit tests probleme, daher wird er fuer test auskommentiert

    $rootScope.$on(TSAuthEvent[TSAuthEvent.LOGIN_SUCCESS], () => {
        //do stuff if needed
        if (ENV !== 'test') {
            setUserIdToPiwik();
            captureUserInSentry()
        }
    });

    $rootScope.$on(TSAuthEvent[TSAuthEvent.LOGOUT_SUCCESS], () => {
        //do stuff if needed
        if (ENV !== 'test') {
            setUserIdToPiwik();
            captureUserInSentry()
        }
    });

    $rootScope.$on(TSAuthEvent[TSAuthEvent.NOT_AUTHENTICATED], () => {
        //user is not yet authenticated, show loginpage

        let currentPath = angular.copy($location.absUrl());
        $log.debug('not authenticated, going to login page wiht current path ', currentPath);

        //wenn wir schon auf der lognseite oder im redirect sind redirecten wir nicht
        if (($state.current !== undefined && $state.current.name !== 'login')
            && ($state.current !== undefined && $state.current.name !== 'loginanlaufstelle')
            && ($state.current !== undefined && $state.current.name !== 'locallogin')
        ) {
            $log.debug('user is not logged in, redirecting to login page from ', currentPath);
            $state.go('login', {relayPath: currentPath, type: 'login'});
        } else {
            $log.info('suppressing redirect to ', currentPath);
        }

    });

    $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
        errorService.clearAllOfSeverity(TSErrorLevel.SEVERE);
    });

//     Attempt to restore a user session upon startup
    if (authServiceRS.initWithCookie()) {
        $log.debug('logged in from cookie');
    }

    if (ENV !== 'test') {
        //Hintergrundfarbe anpassen (user-acceptance-test system kann zB andere Farbe haben)
        let applicationPropertyRS = $injector.get<ApplicationPropertyRS>('ApplicationPropertyRS');
        applicationPropertyRS.getBackgroundColor().then((prop: TSApplicationProperty) => {
            if (prop && prop.value && prop.value !== '#FFFFFF') {
                angular.element('.navbar-serf').css('background', prop.value);
            }
        });

        //if we are doing a 'npm run test run' we do not need to track phantom-js
        applicationPropertyRS.getPiwikSiteId().then((piwikAppProp: TSApplicationProperty) => {
            let siteID = piwikAppProp.value !== undefined ? piwikAppProp.value : undefined;
            initPiwik(siteID);
        });

        applicationPropertyRS.getSentryEnvName().then((sentryEnvName: TSApplicationProperty) => {
            if (sentryEnvName && sentryEnvName.value) {
                Raven.setEnvironment(sentryEnvName.value);
            } else {
                Raven.setEnvironment('unspecified');

            }
        })
    }

    function initPiwik(siteId: string | undefined) {
        if (!siteId) {
            $log.debug('tracker not started');
            return;
        }

        let piwikUrl = piwikService.getPiwikUrl();

        piwikService.push(['setTrackerUrl', piwikUrl + 'piwik.php']);
        piwikService.push(['setSiteId', siteId]);

        setUserIdToPiwik();
        captureUserInSentry();
        updatePiwikStateChange(null, $window.location.href, '');  //inital entry to tracking, call again on page-state change

        let scriptElement = document.createElement('script');
        let firstScript = document.getElementsByTagName('script')[0];
        scriptElement.type = 'text/javascript';
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.src = piwikUrl + 'piwik.js';
        if (firstScript !== undefined && firstScript.parentNode !== undefined && firstScript.parentNode !== null) {
            firstScript.parentNode.insertBefore(scriptElement, firstScript);
        } else {
            $log.warn('could not start piwik tracking because no script tag was found on page');
        }
    }

    function setUserIdToPiwik() {
        // get username, not using null as this produces an error in the piwik script
        let currPrincipal = authServiceRS.getPrincipal();
        let username = currPrincipal && currPrincipal.email ? currPrincipal.email : '';

        piwikService.push(['setUserId', username]);
    }

    function captureUserInSentry() {
        let currPrincipal = authServiceRS.getPrincipal();
        let username = currPrincipal && currPrincipal.email ? currPrincipal.email : undefined;
        let maxRole;
        maxRole = authServiceRS.getHighestRoleOfBenutzer(currPrincipal && currPrincipal.roles ? currPrincipal.roles : []);
        Raven.setUserContext({
            email: username,
            maxRole: maxRole,
        });
    }

    /**
     * Update the piwik super global variable to track page changes without actually routing.
     *
     * @see https://piwik.org/blog/2017/02/how-to-track-single-page-websites-using-piwik-analytics
     * @param {?angular.IAngularEvent} event
     * @param {string} newUrl
     * @param {string} oldUrl
     */
    function updatePiwikStateChange(event: IAngularEvent | null, newUrl: string, oldUrl: string) {
        piwikService.push(['setReferrerUrl', oldUrl]);
        piwikService.push(['setCustomUrl', newUrl]);
        // as our document title is useless we just use part of the url as title
        let hashPrefix = newUrl.indexOf('#/');
        let documentTitle = hashPrefix === -1 ? window.document.title : newUrl.substr(hashPrefix + 2);
        piwikService.push(['setDocumentTitle', documentTitle]);

        // remove all previously assigned custom variables, requires Piwik 3.0.2
        piwikService.push(['deleteCustomVariables', 'page']);
        piwikService.push(['setGenerationTimeMs', 0]);
        piwikService.push(['trackPageView']);
    }
}

function getStates(): IState[] {
    return [
        /* Add New States Above */
    ];
}



// WEBPACK FOOTER //
// ./src/app/core/core.route.ts